import { render, staticRenderFns } from "./MenuInfoTile.vue?vue&type=template&id=09708670&scoped=true"
import script from "./MenuInfoTile.vue?vue&type=script&lang=js"
export * from "./MenuInfoTile.vue?vue&type=script&lang=js"
import style0 from "./MenuInfoTile.vue?vue&type=style&index=0&id=09708670&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09708670",
  null
  
)

export default component.exports